import { cloneDeep } from 'lodash-es';

import { CLEAR_COMPOSITES_PAGE, SET_COMPOSITE, SET_COMPOSITES_PAGE } from './mutation-types';

export default {
  [CLEAR_COMPOSITES_PAGE](state) {
    state.compositesMap = {};
    state.compositesPage = {};
  },

  [SET_COMPOSITE](state, { id, page }) {
    state.compositesMap[id] = cloneDeep(page);
  },

  [SET_COMPOSITES_PAGE](state, page) {
    state.compositesPage = cloneDeep(page);
  },
};
